import { Route, RouteConfig } from '@mews-distributor/common';
import { TransitionName } from '@optimus-web/core';

export const getTransitionKey = (currentRoute: Route, previousRoute?: Route): TransitionName => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (!previousRoute) {
        return TransitionName.FadeIn;
    }

    return RouteConfig[currentRoute].order < RouteConfig[previousRoute].order
        ? TransitionName.SlideInFromRight
        : TransitionName.SlideInFromLeft;
};
